import React from 'react';
import Dropdown from './components/Dropdown';

const App: React.FC = () => {
  return (
    <div className="h-screen">
      <Dropdown />
    </div>
  );
};

export default App;
